import React from "react";
import Accordions from "../../../components/Accordions";

const Sem1Ft1 = () => {
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1Xt1ifz_Qc4fH_LbFj-LOFW4sLH3bAyYg/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/1fO2P-Vvp2Jppt7QkkBeeboefp-TrnamC/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1U6ja7JkTCBA9sMv-401JWrb9ZAti0WRB/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">FT Sem - 1</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem1Ft1;
